import "./ShieldPage.scss";

import { useEffect } from "react";

import { LoadingOverlay } from "../../../../components/LoadingOverlay/LoadingOverlay";
import type { IOrganization } from "../../../../contexts/organizations/organizationsContext";
import { useRequests } from "../../../../hooks/reactQueryHooks/useRequests";
import { useQueryParams } from "../../../../hooks/useQueryParams";
import { Badges } from "../Badges/Badges";
import { Filters } from "../Filters";
import ShieldTable from "../ShieldTable/ShieldTable";

interface IProps {
  currentOrganization: IOrganization | undefined;
}

const ShieldPage: React.FC<IProps> = ({ currentOrganization }) => {
  const { queryValue: searchQuery } = useQueryParams({
    queryStr: "s",
  });

  const { queryValue: page, handleChange: setPage } = useQueryParams({
    queryStr: "p",
  });

  const request = {
    PageIndex: page ? Number(page) : null,
    Search: searchQuery || "",
  };

  const { data, isLoading, isFetching } = useRequests(
    currentOrganization?.id || "",
    request,
  );

  useEffect(() => {
    setPage("1", true);
  }, [searchQuery, setPage]);

  useEffect(() => {
    setPage("1", true);
  }, [currentOrganization, setPage]);

  const { items, totalCount: total } = data || {};

  return (
    <>
      <Badges />
      <div className="card flex-shrink-1 flex-grow-1">
        <div className="app-container-inner-wrapper d-flex flex-column">
          {(isFetching || isLoading) && <LoadingOverlay />}
          <Filters />
          <ShieldTable
            items={items || []}
            totalItems={total}
            isLoading={isLoading || isFetching}
          />
        </div>
      </div>
    </>
  );
};

export { ShieldPage };
